import { __assign } from "tslib";
import React from 'react';
import useFocusVisible from '../internal/hooks/focus-visible';
import InternalIcon from '../icon/internal';
import clsx from 'clsx';
import styles from './styles.css.js';
export var ExpandableSectionHeader = function (_a) {
    var id = _a.id, className = _a.className, variant = _a.variant, children = _a.children, expanded = _a.expanded, ariaControls = _a.ariaControls, ariaLabelledBy = _a.ariaLabelledBy, onKeyUp = _a.onKeyUp, onKeyDown = _a.onKeyDown, onClick = _a.onClick;
    var focusVisible = useFocusVisible();
    var icon = React.createElement(InternalIcon, { className: clsx(styles.icon, expanded && styles.expanded), name: "caret-down-filled" });
    var ariaAttributes = {
        'override-focus': 'true',
        'aria-controls': ariaControls,
        'aria-expanded': expanded
    };
    var triggerClassName = clsx(styles.trigger, styles["trigger-" + variant], expanded && styles['trigger-expanded']);
    if (variant === 'navigation') {
        return (React.createElement("div", { id: id, className: clsx(className, triggerClassName), onClick: onClick },
            React.createElement("button", __assign({ className: styles['icon-container'], type: "button", "aria-labelledby": ariaLabelledBy }, focusVisible, ariaAttributes), icon),
            children));
    }
    return (React.createElement("div", __assign({ id: id, role: "button", className: clsx(className, triggerClassName, styles.focusable, expanded && styles.expanded), tabIndex: 0, onKeyUp: onKeyUp, onKeyDown: onKeyDown, onClick: onClick }, focusVisible, ariaAttributes),
        React.createElement("div", { className: styles['icon-container'] }, icon),
        children));
};
//# sourceMappingURL=expandable-section-header.js.map